module.exports = __webpack_public_path__ + "static/media/folder.8dac02ef.svg";